import { isNil } from "es-toolkit";
import { LuClock, LuLock } from "react-icons/lu";

import { setDialog } from "@/components/app/dialogs/dialog-provider";
import CoinPriceFormatter from "@/components/shared/coin-price-formatter";
import { Button } from "@/components/ui/button";
import { DIALOG } from "@/utils/dialog-routes";
import { cn } from "@/utils/lib";

export const WalletLockedTokensCell = ({
  totalLockedUsdValue,
  coinPublicKey,
  coinUsername,
  refetchData,
  holderPublicKey,
  coinPrice,
  showValue = true,
  triggerBtnClassName = "",
}: {
  totalLockedUsdValue?: number | null;
  coinPublicKey?: string | null;
  coinUsername?: string | null;
  refetchData?: () => void;
  holderPublicKey: string;
  coinPrice?: number | null;
  showValue?: boolean;
  triggerBtnClassName?: string;
}) => {
  return (
    <>
      {!!totalLockedUsdValue && totalLockedUsdValue > 0 && (
        <div className="flex flex-col gap-2">
          {showValue && (
            <div className="flex items-center gap-1 text-muted">
              <LuLock />
              <CoinPriceFormatter price={totalLockedUsdValue} />
            </div>
          )}
          <Button
            variant="ghost"
            size="xs"
            onClick={() => {
              if (!coinPublicKey || !holderPublicKey || isNil(coinPrice)) {
                return;
              }

              setDialog(DIALOG.UnlockTokens, {
                open: true,
                params: {
                  coinPrice: String(coinPrice),
                  coinPublicKey,
                  holderPublicKey,
                  ...(coinUsername ? { coinUsername } : {}),
                },
                props: {
                  onUnlockSuccess: refetchData,
                },
              });
            }}
            className={cn(
              "m-0 mb-2 flex h-0 items-center gap-1 p-0",
              triggerBtnClassName,
            )}
          >
            <LuClock />
            View Unlocks
          </Button>
        </div>
      )}
    </>
  );
};
